/* eslint-disable arrow-parens */
import {debounce, isMobile} from '../../helpers';
import {Block} from './Block';
import {DisplayText} from './DisplayText';
import {Layer} from './Layer';
import {LayerComposite} from './LayerComposite';
import {Player} from './Player';
import {Popup} from './Popup';
import {Coin} from './Coin';
import {Tent} from './Tent';
import {Controls} from './Controls';
import {Test} from './Test';
import {StartScreen} from './StartScreen';
import {BlockDecor} from './BlockDecor';
import {Sound} from './Sound';
import {BlockFinish} from './BlockFinish';

export class Game {
	constructor() {
		this.wrapper = document.getElementById('game');
		this.canvas = document.getElementById('canvas');
		this.ctx = this.canvas.getContext('2d');
		this.gameScale = this.setScaleGame();
		this.setSize();
		// eslint-disable-next-line no-unused-expressions
		this.width;
		// eslint-disable-next-line no-unused-expressions
		this.height;
		this.speed = 7;
		this.start = false;
		this.state = 'pause';
		this.fps = 60;
		this.score = 0;
		// Максимальное колличество блоков в игре
		this.maxBlocks = 30;
		// Колличество последних блоков на экране
		this.lastBlocks = this.maxBlocks - 3;
		this.groundMargin = 40;
		this.backgroundColor = '#2CBDEE';
		this.controls = new Controls(this);
		this.player = new Player(this);
		this.river = new Layer(document.getElementById('river'), 3070, 108, 188, 0.87, this);
		this.ground = new Layer(document.getElementById('ground'), 2850, 80, 80, 1, this);
		this.ground2 = new Layer(document.getElementById('ground-2'), 2800, 51, 239, 0.75, this);
		this.backgrounds = [
			// последовательность важна, так как они идут по слоям и нижние перекрывают верхние слои
			this.ground2,
			new LayerComposite(1800, 555, 469, 0.60, this),
			new Layer(document.getElementById('cloud'), 3000, 115, 600, 0.4, this),
			this.river,
			this.ground,
		];
		this.decor = [
			new BlockDecor('timber', this),
			new BlockDecor('duck', this, 0.8),
		];
		this.blockStep = 0;
		this.blocks = [
			new Block(this),
			new Block(this),
			new Block(this),
		];
		// Колличество блоков прошедших по экрану
		this.currentBlocks = 0;
		this.displayText = new DisplayText(this);
		this.popupMain = new Popup('.popup--main', this);
		this.tent = new Tent(this);
		this.coin = new Coin(this);
		this.test = new Test(this);
		// Показывать новые блоки
		this.showNewBlocks = true;
		this.startScreen = new StartScreen(this);
		this.maxScore = 100;
		this.finish = false;
		this.blockFinish = new BlockFinish(this);
		this.sound = new Sound();
	}

	// eslint-disable-next-line class-methods-use-this
	setScaleGame() {
		if (isMobile()) {
			return 2;
		} else if (window.innerWidth < 1800) {
			return 1;
		} else if (window.innerWidth < 2100) {
			return 0.8;
		}

		return 0.6;
	}

	setSize() {
		this.canvas.width = this.wrapper.clientWidth * this.gameScale;
		this.canvas.height = (this.wrapper.clientHeight - document.getElementById('controls').clientHeight) * this.gameScale;
		this.width = this.canvas.width;
		this.height = this.canvas.height;
	}

	updateScore(value) {
		this.score += value;
		this.displayText.pointAnimate(value);
	}

	blocksAnimation() {
		this.blocks.forEach((block) => {
			block.update(this.player);
			block.draw();
		});
	}

	backgroundAnimation() {
		this.backgrounds.forEach((bg) => {
			bg.update();
			bg.draw();
		});

		this.decor.forEach((decor) => {
			decor.update();
			decor.draw();
		});
	}

	stopGame() {
		if (this.currentBlocks >= this.lastBlocks) {
			this.showNewBlocks = false;
		}

		if (this.currentBlocks >= this.maxBlocks) {
			this.finish = true;
			// this.pause();
			// this.popupMain.openFinal();
		}
	}

	drawGame(fpsInterval) {
		this.ctx.clearRect(0, 0, this.width, this.height);
		this.ctx.fillStyle = this.backgroundColor;
		this.ctx.fillRect(0, 0, this.width, this.height);

		this.backgroundAnimation();
		this.blocksAnimation();
		this.coin.update(fpsInterval);
		this.coin.draw();
		this.tent.update(this.player, this.score, this.pause);
		this.tent.draw();
		this.displayText.draw();
		this.blockFinish.update();
		this.blockFinish.draw();
		this.player.update(fpsInterval);
		this.player.draw();
		this.test.showBtn();

		this.stopGame();
	}

	pause() {
		this.state = 'pause';
		this.controls.changeState(this.controls.pause, true);
	}

	play() {
		this.state = 'play';
		this.controls.changeState(this.controls.pause, false);

		if (!this.coin.infoBlock.isHide) {
			this.coin.infoBlock.close();
		}

		if (this.controls.aboutOpen) {
			this.controls.handlerAbout();
		}

		if (this.popupMain.open) {
			this.popupMain.handler();
		}

		this.sound.playBackgroundSound();
	}

	resize = debounce(() => {
		this.gameScale = this.setScaleGame();
		this.setSize();
		this.player.resize();
		this.backgrounds.forEach(el => el.resize());
		this.blocks.forEach(el => el.resize());
		this.blocks.forEach(block => block.resize());
		this.tent.resize();
		this.coin.resize();
		this.blockFinish.resize();

		this.decor.forEach((decor) => {
			decor.resize();
		});

		if (window.innerHeight > window.innerWidth) {
			this.pause();
		}

		this.drawGame(16);
	}, 300);

	reset() {
		this.score = 0;
		this.currentBlocks = 0;
		this.blockStep = 0;
		this.showNewBlocks = true;
		this.start = true;

		this.coin.reset();
		this.popupMain.reset();
		this.tent.reset();
		this.blockFinish.reset();
		this.test.reset();

		// сброс положения фона
		this.backgrounds.forEach(bg => {
			bg.x = 0;
		});

		// сброс положения декораций
		this.decor.forEach((decor) => {
			decor.reset();
		});

		this.play();
	}
}
